"use client";

import { Navigate } from "react-router-dom";

/** Legacy URL — canonical private events page is /private-events. */
export default function ContactRedirectPage() {
  return <Navigate to="/private-events" replace />;
}
